import { Link } from "react-router-dom";
import { contactInfo } from "@/mocks/catalog";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-950 text-background-50 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50 text-lg">
                <i className="ri-play-circle-fill"></i>
              </span>
              <span className="text-lg font-black tracking-tight">豆花视频</span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              高清影视资源精选与视频内容平台，涵盖电影、电视剧、综艺等多种类型，专注内容展示与资讯导航。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">影视分类</h4>
            <ul className="space-y-2 text-sm text-background-50/70">
              <li>
                <Link to="/category/movie" className="hover:text-accent-400 transition-colors cursor-pointer">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="hover:text-accent-400 transition-colors cursor-pointer">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/category/variety" className="hover:text-accent-400 transition-colors cursor-pointer">
                  综艺频道
                </Link>
              </li>
              <li>
                <Link to="/search" className="hover:text-accent-400 transition-colors cursor-pointer">
                  搜索影视
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">关于我们</h4>
            <ul className="space-y-2 text-sm text-background-50/70">
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
                  网站介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
                  版权与免责声明
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
                  联系方式
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-50/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href={`mailto:${contactInfo.email}`} className="hover:text-accent-400 transition-colors">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span className="leading-relaxed">{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/15 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-50/60">
          <p>© {year} 豆花视频. 保留所有权利。本站为影视内容展示与资讯平台，不提供在线播放与下载服务。</p>
          <p className="flex items-center gap-1">
            <i className="ri-shield-check-line"></i>
            内容信息仅供参考
          </p>
        </div>
      </div>
    </footer>
  );
}